import { render, staticRenderFns } from "./ArticulosEquivalentes.vue?vue&type=template&id=5bcc2684&"
import script from "./ArticulosEquivalentes.vue?vue&type=script&lang=js&"
export * from "./ArticulosEquivalentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports